import { IntegrationsService } from '@weave/schema-gen-ts/dist/schemas/syncapp/integrations-service/integrations_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaIntegrationsV1Service = bindHTTP(IntegrationsService);
export const serviceName = 'integrations-v1' as const;
